/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  TRIGGER_CYCLONE: {},
};

const MACHINE_CONFIG = {
  id: "io.vlinder.klefki.trigger.cyclone",
  initial: "idle",
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ["resetAction"],
      on: {
        START: { target: "TRIGGER_CYCLONE" },
      },
    },
    TRIGGER_CYCLONE: {
      invoke: {
        id: "triggerCyclone",
        src: "triggerCyclone",
        onDone: {
          target: "TRIGGER_CYCLONE_SUCCESS",
          actions: ["successAction"],
        },
        onError: {
          target: "TRIGGER_CYCLONE_FAILED",
          actions: ["failureAction"],
        },
      },
    },
    TRIGGER_CYCLONE_SUCCESS: {
      on: {
        START: { target: "TRIGGER_CYCLONE" },
      },
    },
    TRIGGER_CYCLONE_FAILED: {
      on: {
        START: { target: "TRIGGER_CYCLONE" },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
